import React, { useEffect, useState } from "react";
import axios, { decryptData, removeBracketedText } from "../Axiosinstance";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StandardFonts } from "pdf-lib";

import { FaPlus } from "react-icons/fa";
import Teacher_Deployment from "../pdf/TEACHER_DEPLOYMENT.pdf";
import { PDFDocument, rgb } from "pdf-lib";
import { TextEncoder } from "util";
import { buttonBackgroundColor } from "../common";

const IntakeDetailsTable = () => {
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  const intakeId1 = decryptData(decodeURIComponent(intakeId));

  const [scheduleDetails, setScheduleDetails] = useState([]);
  const [intake, setIntake] = useState({});
  const [moduleDetailsMap, setModuleDetailsMap] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [trainerName, setTrainerName] = useState("");
  const [trainerId, setTrainerId] = useState(null);
  const [facilitatorData, setFacilitatorData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [selectedFacilitator, setSelectedFacilitator] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    fetchData();
  }, [batchId1, intakeId1]);

  const fetchData = () => {
    axios
      .get(`/intake-details/full/${intakeId1}/batch/${batchId1}`)
      .then((response) => {
        const details = response.data.intakeDetails;
        const trainerHistories = response.data.trainerHistories;
        console.log("trainerHistories", details)
        if (details.length > 0) {
          const scheduleDetails = details[0].scheduleDateDetails.map((schedule) => {
            console.log(`Schedule Period: ${schedule.startDate} to ${schedule.endDate}`);

            const startDate = new Date(schedule.startDate);
            const endDate = new Date(schedule.endDate);

            // Find trainers from trainerHistories who were active during this period
            const assignedTrainers = new Set();

            trainerHistories.forEach((trainer) => {
              const assignedDate = new Date(trainer.assignedDate);
              const unassignedDate = trainer.unassignedDate ? new Date(trainer.unassignedDate) : null;

              if (
                assignedDate <= endDate && // Trainer was assigned before or within this period
                (unassignedDate === null || unassignedDate >= startDate) // Trainer was still assigned or left after this period
              ) {
                assignedTrainers.add(trainer.trainer);
              }
            });

            return {
              ...schedule,
              assignedTrainers: schedule.trainer || "",
            };
          });

          setScheduleDetails(scheduleDetails);
          setIntake({
            id: details[0].id,
            intakeId: details[0].intakeId,
            course: details[0].course,
            lessonsPerWeek: details[0].lessonsPerWeek,
          });

          const map = {};
          details[0].moduleDetails.forEach((module) => {
            map[module.id] = module.moduleName;
          });
          setModuleDetailsMap(map);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the intake details!", error);
      });
  };







  const fetchFacilitatorDetails = () => {
    axios
      .get("/facilitators")
      .then((response) => setFacilitatorData(response.data))
      .catch((error) =>
        console.error("Error fetching facilitator data:", error)
      );
  };

  const handleOpenDialog = (schedule) => {
    setSelectedSchedule(schedule);
    const [name, id] = removeBracketedText(schedule.trainer).split("(");
    setTrainerName(name.trim());
    setTrainerId(id ? parseInt(id.replace(")", ""), 10) : null);
    fetchFacilitatorDetails();
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedSchedule(null);
    setSelectedFacilitator(null);
  };

  const handleSelectTrainer = (facilitator) => {
    // Set the selected facilitator
    setSelectedFacilitator(facilitator);

    // Format the trainer name as 'name(id)'
    const formattedTrainerName = `${facilitator.name}(${facilitator.id})`;
    setTrainerName(formattedTrainerName);
    setTrainerId(facilitator.id);

    toast.success(`${formattedTrainerName} has been set as the trainer!`);
  };

  const handleRemoveTrainer = () => {
    setTrainerName("");
    setTrainerId(null);
    setSelectedFacilitator(null);
  };

  const handleSaveTrainer = () => {
    if (trainerName && selectedFacilitator) {
      axios
        .put(
          `/intake-details/${intake.id}/schedule-date/${selectedSchedule.id}/trainer`,
          { trainerName }
        )
        .then((response) => {
          toast.success("Trainer updated successfully!");
          handleCloseDialog();
          fetchData(); // Refresh the data after updating
        })
        .catch((error) => {
          toast.error("There was an error updating the trainer!");
          console.error("There was an error updating the trainer!", error);
        });
    } else {
      toast.error("Please select a trainer before saving.");
    }
  };


  const handleOpenPdf = async () => {
    // Fetch the existing PDF
    const existingPdfBytes = await fetch(Teacher_Deployment).then((res) =>
      res.arrayBuffer()
    );

    // Load the existing PDF
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const page = pdfDoc.getPages()[0]; // Assuming single-page PDF

    const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const defaultFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // Function to wrap text
    const wrapText = (text, maxWidth, font, fontSize) => {
      const words = text.split(" ");
      let lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    // Function to draw wrapped text
    const drawWrappedText = (page, text, x, y, font, fontSize, maxWidth) => {
      const wrappedLines = wrapText(text, maxWidth, font, fontSize);
      wrappedLines.forEach((line, index) => {
        page.drawText(line, {
          x: x,
          y: y - index * 12, // Line spacing
          size: fontSize,
          font,
          color: rgb(0, 0, 0),
        });
      });
    };

    // Define static positions for batch number and other data
    const positions = [
      { x: 350, y: 465, text: `BATCH NO: ${intake.intakeId}` },
    ];

    // Draw static text on the PDF
    positions.forEach((pos) => {
      page.drawText(pos.text, {
        x: pos.x,
        y: pos.y,
        size: 12,
        font,
        color: rgb(0, 0, 0),
      });
    });

    // Draw intakeId six times
    let yPosition = 376;
    const spacing = 42;
    for (let i = 0; i < 6; i++) {
      let intakeText = `${intake.intakeId}`;
      // Only wrap if intakeId starts with "DCOMPE"
      if (intakeText.startsWith("DCOMPE") && intakeText.includes("-")) {
        let parts = intakeText.split("-");
        // Draw "DCOMPE" on the first line
        page.drawText(parts[0], {
          x: 183,
          y: yPosition,
          size: 11,
          font,
          color: rgb(0, 0, 0),
        });
        // Draw "-22" (or other suffix) on the next line
        page.drawText(`-${parts[1]}`, {
          x: 183,
          y: yPosition - 15, // Moves down slightly
          size: 11,
          font,
          color: rgb(0, 0, 0),
        });
      } else {
        // Draw normally if not "DCOMPE"
        page.drawText(intakeText, {
          x: 183,
          y: yPosition,
          size: 11,
          font,
          color: rgb(0, 0, 0),
        });
      }
      yPosition -= spacing;
    }

    // 🔹 Draw all trainers in Teacher Column (with wrapped text)
    let teacherYPosition = 377;

    scheduleDetails.forEach((schedule) => {
      const trainerText = removeBracketedText(schedule.assignedTrainers);
      console.log("Original trainerText:", trainerText); // Log the original trainer text

      if (trainerText) {
        let trainerToDisplay;

        // Check if the name contains a comma
        if (trainerText.includes(',')) {
          // If there is a comma, take the last name after the comma
          const trainers = trainerText.split(',').map(name => name.trim());
          trainerToDisplay = trainers[trainers.length - 1]; // Get the last name after the comma
        } else {
          // If there is no comma, display the full name
          trainerToDisplay = trainerText.trim();
        }

        console.log("Trainer to display:", trainerToDisplay); // Log the name to be displayed

        // Draw the name
        drawWrappedText(page, trainerToDisplay, 50, teacherYPosition, defaultFont, 11, 100);

        // Adjust Y position for the next name
        teacherYPosition -= 42;
      } else {
        console.log("No trainer text available!");
      }
    });


    // 🔹 Draw Module (with wrapped text)
    let moduleYPosition = 380;
    scheduleDetails.forEach((schedule) => {
      const moduleText = moduleDetailsMap[schedule.startModulus] || "N/A";
      drawWrappedText(page, moduleText, 360, moduleYPosition, defaultFont, 10, 110);
      moduleYPosition -= spacing;
    });

    // 🔹 Draw "Lessons per Week" (with wrapped text)
    let lessonsYPosition = 380;
    for (let i = 0; i < 6; i++) {
      drawWrappedText(page, `${intake.lessonsPerWeek} Hours`, 480, lessonsYPosition, defaultFont, 10, 110);
      lessonsYPosition -= spacing;
    }

    // 🔹 Draw "Details of Deployment/Remarks" (with wrapped text)
    let remarksYPosition = 380;

    scheduleDetails.forEach((schedule) => {
      const formattedStartDate = schedule.startDate
        ? new Date(schedule.startDate).toLocaleDateString("en-GB")
        : "N/A";
      const formattedEndDate = schedule.endDate
        ? new Date(schedule.endDate).toLocaleDateString("en-GB")
        : "N/A";
      const formattedDate = `${formattedStartDate} To ${formattedEndDate}`;
      drawWrappedText(page, formattedDate, 550, remarksYPosition, defaultFont, 10, 120);
      remarksYPosition -= spacing;
    });

    // 🔹 Draw Course (with wrapped text)
    let courseYPosition = 380;
    for (let i = 0; i < 6; i++) {
      drawWrappedText(page, `${intake.course}`, 243, courseYPosition, defaultFont, 10, 110);
      courseYPosition -= spacing;
    }

    // 🔹 Draw Venue (with wrapped text)
    let venueYPosition = 375;
    scheduleDetails.forEach((schedule) => {
      const venueText = schedule.venue === "Online/Classroom" ? "Online" : schedule.venue || "N/A";
      drawWrappedText(page, venueText, 695, venueYPosition, font, 11, 80);
      venueYPosition -= 42;
    });

    // Serialize and open PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };


  return (
    <div className='container-responsive' >

      <Box sx={{ padding: 2 }}>
        <ToastContainer />

        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenPdf}
          sx={{ mb: 2 }}
          style={{ backgroundColor: buttonBackgroundColor }}
        >
          Open Teacher Deployment PDF
        </Button>

        <TableContainer component={Paper} style={{
          boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
          borderRadius: '8px',
          maxHeight: '500px',  // Set a max height for the container
          overflowY: 'auto'   // Enable vertical scrolling for the table body
        }}>
          <Table aria-label="schedule table">
            <TableHead>
              <TableRow style={{
                backgroundColor: '#f5f5f5',
                position: 'sticky',
                top: 0,
                zIndex: 1 // Ensure it stays above the table body when scrolling
              }}>
                <TableCell style={{ fontWeight: "bold" }}>
                  Trainer
                </TableCell >
                <TableCell style={{ fontWeight: "bold" }}>
                  Course Intake
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Course Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Module
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Lessons per Week
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>

                  Details of Deployment/Remarks

                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Venue
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scheduleDetails.map((schedule) => (
                <TableRow key={schedule.id}>
                  <TableCell>{removeBracketedText(schedule.assignedTrainers)}</TableCell>
                  <TableCell>{intake.intakeId}</TableCell>
                  <TableCell>{intake.course}</TableCell>
                  <TableCell>{moduleDetailsMap[schedule.startModulus]}</TableCell>
                  <TableCell>{intake.lessonsPerWeek} Hours</TableCell>
                  <TableCell>
                    {schedule.startDate
                      ? new Date(schedule.startDate).toLocaleDateString("en-GB")
                      : "N/A"}
                    {" "}To{" "}
                    {schedule.endDate
                      ? new Date(schedule.endDate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </TableCell>
                  <TableCell>{schedule.venue}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleOpenDialog(schedule)}
                      style={{ backgroundColor: buttonBackgroundColor }}
                    >
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          sx={{
            "& .MuiDialog-paper": {
              padding: 2,
              overflowY: "auto",
              maxWidth: "1000px",
            },
          }} // Compact, user-friendly size
        >
          <DialogTitle>Edit Schedule Details</DialogTitle>
          <DialogContent>
            {selectedSchedule ? (
              <Box sx={{ padding: 2 }}>
                <div className="row align-items-center mb-3">
                  {/* Search Input */}
                  <div className="col-12 col-md-6">
                    <label htmlFor="search" className="form-label fw-semibold">Search</label>
                    <div className="input-group">
                      <span className="input-group-text">🔍</span>
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        placeholder="Search by name, email, or NRIC"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Items Per Page Dropdown */}
                  <div className="col-12 col-md-4">
                    <label htmlFor="itemsPerPage" className="form-label fw-semibold">Items Per Page</label>
                    <div className="input-group">
                      <span className="input-group-text">Show</span>
                      <select
                        id="itemsPerPage"
                        className="form-select"
                        value={itemsPerPage}
                        onChange={(e) => {
                          setItemsPerPage(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* Facilitator Table */}
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>NRIC</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {facilitatorData.length > 0 ? (
                        facilitatorData
                          .filter(
                            (facilitator) =>
                              facilitator.name
                                .toLowerCase()
                                .includes(searchText.toLowerCase()) ||
                              facilitator.email
                                .toLowerCase()
                                .includes(searchText.toLowerCase()) ||
                              facilitator.nric
                                .toLowerCase()
                                .includes(searchText.toLowerCase())
                          )
                          .slice(
                            (currentPage - 1) * itemsPerPage,
                            currentPage * itemsPerPage
                          )
                          .map((facilitator) => (
                            <tr key={facilitator.id}>
                              <td>{facilitator.name}</td>
                              <td>{facilitator.email}</td>
                              <td>{facilitator.nric}</td>
                              <td>
                                {selectedFacilitator &&
                                  selectedFacilitator.id === facilitator.id ? (
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleRemoveTrainer}
                                    size="small"
                                    style={{ backgroundColor: buttonBackgroundColor }}
                                  >
                                    Remove Trainer
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                      handleSelectTrainer(facilitator)
                                    }
                                    size="small"
                                    disabled={!!selectedFacilitator}
                                    style={{ backgroundColor: buttonBackgroundColor }}
                                  >
                                    Assign Trainer
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No facilitators found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between mt-3">
                  <span>
                    Showing page {currentPage} of{" "}
                    {Math.ceil(facilitatorData.length / itemsPerPage)}
                  </span>
                  <div>
                    <span>Page: </span>
                    <select
                      className="form-control d-inline-block"
                      value={currentPage}
                      onChange={(e) => setCurrentPage(Number(e.target.value))}
                      style={{ width: "auto" }}
                    >
                      {Array.from(
                        {
                          length: Math.ceil(
                            facilitatorData.length / itemsPerPage
                          ),
                        },
                        (_, i) => i + 1
                      ).map((page) => (
                        <option key={page} value={page}>
                          {page}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </Box>
            ) : (
              <p>Loading schedule details...</p>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCloseDialog}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveTrainer}
              disabled={!selectedFacilitator}
              style={{
                backgroundColor: !selectedFacilitator ? '' : 'green',
                color: !selectedFacilitator ? 'white' : undefined
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};

export default IntakeDetailsTable;
